<template>
    <v-row>
        <v-col
            cols="1"
            align="center"
            align-self="center"
        >
            <v-row>
                <v-col>
                    <div style="display: flex; flex-direction: row;">
                        <div
                            :style="{
                                backgroundColor: $color.coro.recommendationClass[recommendationClass],
                                border: `2px solid ${$color.coro.white}`,
                                display: 'inline-block',
                                minWidth: '40px'
                            }"
                            class="px-3 py-5"
                        >
                            <strong>{{ recommendationClass }}</strong>
                        </div>
                        <div
                            :style="{
                                backgroundColor: $color.coro.recommendationClass[levelOfEvidence],
                                border: `2px solid ${$color.coro.white}`,
                                display: 'inline-block',
                                minWidth: '40px'
                            }"
                            class="px-3 py-5"
                        >
                            <strong>{{ levelOfEvidence }}</strong>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-col>
        <v-col class="ml-1">
            <v-row>
                <v-col cols="12" style="display: flex; flex-direction: column; align-items: center, justify-content: flex-start">
                    <h4>{{ sourceText }}</h4>
                    <span><strong>{{ $ucfirst($t("dss.source")) }}:</strong> {{ source }}</span>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
/**
 * Component RecommendationClass.vue
 *
 * @module RecommendationClass
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/DSS/RecommendationClass.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "RecommendationClass",
  props: {
    recommendationClass: {
      type: String,
    },
    levelOfEvidence: {
      type: String,
    },
    source: {
      type: String,
    },
    sourceText: {
      type: String,
    },
  },
};
</script>